export default {
  title: "Profile",
  tabs: {
    preferences: "Preferences",
    skills: "My Skills",
    security: "Security",
  },
  subtitle: "Manage your personal information and preferences.",
  language: "Language",
  sections: {
    profile: "Profile",
    profileHint: "How you appear to the team.",
    security: "Security",
    securityHint: "Access to your account.",
  },
  languageSuccess: "Language updated successfully",
  languageError: "Failed to update language",
  notSet: "Not set",
  passwordLabel: "Password",
  changePassword: "Change Password",
  passwordResetEmailSent: "Password reset email sent successfully. Please check your inbox.",
  passwordResetError: "Failed to request password reset. Please try again later.",
  emailNotFound: "Email not found. Please update your profile with a valid email.",
  // Cada idioma no PRÓPRIO idioma, e igual nos dois locales: quem só lê
  // português, numa tela em inglês, procura "Português" — não "Portuguese".
  languages: {
    en: "English",
    pt: "Português"
  },
  avatar: {
    invalidFileType: "Invalid file type",
    invalidFileTypeDescription: "Please upload an image file",
    fileTooLarge: "File too large",
    fileTooLargeDescription: "Please upload an image smaller than 5MB",
    updateSuccess: "Profile picture updated",
    updateSuccessDescription: "Your profile picture has been updated successfully",
    updateError: "Failed to update profile picture",
    updateErrorDescription: "Failed to update avatar",
    change: "Change picture",
    remove: "Remove picture",
    removeSuccess: "Profile picture removed",
    removeSuccessDescription: "Your profile picture has been removed successfully",
    removeErrorDescription: "Failed to remove profile picture"
  },
  displayName: {
    label: "Name",
    placeholder: "Enter your name",
    updateSuccess: "Profile updated",
    updateSuccessDescription: "Your display name has been updated successfully",
    updateError: "Error",
    updateErrorDescription: "Failed to update display name"
  },
  position: {
    label: "Role / Position",
    placeholder: "e.g. Senior Product Manager",
    notSet: "Not set",
    updateSuccess: "Role updated",
    updateSuccessDescription: "Your role has been updated successfully",
    updateError: "Error updating role",
    updateErrorDescription: "Failed to update your role"
  },
  ai: {
    sectionTitle: "AI preferences",
    sectionDescription: "Personal directives the AI will follow on top of project context.",
    instructionsLabel: "Personal AI instructions (Markdown)",
    instructionsPlaceholder: "Example: Always answer in Portuguese. Always show a short summary at the end of long answers...",
    instructionsHint: "These instructions are passed to every AI agent via the session_load tool. Use Markdown.",
    save: "Save",
    cancel: "Cancel",
    confirmDestructiveLabel: "Confirm before destructive AI actions",
    confirmDestructiveHint: "When ON, AI agents must ask for explicit confirmation before running update or delete tools.",
    updateSuccess: "AI preferences updated",
    updateSuccessDescription: "Your AI preferences have been saved.",
    updateError: "Error updating AI preferences",
    updateErrorDescription: "Failed to save your AI preferences"
  },
  deleteAccount: {
    title: "Danger Zone",
    description: "Irreversible actions that permanently affect your account.",
    buttonTitle: "Delete Account",
    buttonDescription: "Permanently remove your account and all your data.",
    deleteButton: "Delete My Account",
    confirmTitle: "Confirm Account Deletion",
    confirmDescription: "This action is permanent and cannot be undone. All your data will be lost.",
    // For Email/Password users
    confirmLabel: "Enter your password to confirm",
    passwordPlaceholder: "Enter your password",
    confirmHint: "Enter your current password to confirm account deletion.",
    // For OAuth users (Google, Microsoft)
    confirmLabelOAuth: "Type DELETE to confirm",
    confirmWordPlaceholder: "DELETE",
    confirmHintOAuth: "Type DELETE in capital letters to confirm permanent deletion.",
    confirmButton: "Delete Permanently",
    deleting: "Deleting...",
    deletingTitle: "Deleting Account",
    deletingDescription: "Removing your account and all your data. Please wait...",
    deletingStep: "Processing deletion",
    deletingMessage: "Removing all your data...",
    deletedMessage: "Account deleted successfully",
    success: "Account deleted successfully",
    successDescription: "Your account has been permanently removed.",
    error: "Error deleting account",
    errorDescription: "An error occurred while deleting your account.",
    userNotFound: "User not found",
    passwordRequired: "Password is required to confirm deletion",
    confirmWordRequired: "Type DELETE to confirm deletion",
    incorrectPassword: "Incorrect password",
    incorrectConfirmWord: "You must type DELETE to confirm"
  }
} as const;
